import script from "./UploadMain.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadMain.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/addUpload.css?vue&type=style&index=0&id=ceeca676&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceeca676"]])

export default __exports__